<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Thời Khóa Biểu" :link="[{ text: 'Thời khóa biểu', href: '../teachingTimeTable' }]" />
      </div>
    </div>
    <v-card class="mx-4 py-1 full-width full-height">
      <TeacherTimeTable />
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TeacherTimeTable from '@/modules/timeTable/TeacherTimeTable.vue'

export default {
  components: {
    Breadcrumbs,
    TeacherTimeTable
  },

  data() {
    return {}
  },
  computed: {}
}
</script>
<style lang="scss" scoped></style>
